export default __webpack_public_path__ + "static/loupe-navigation-redesign-user-context-menu-bbbaf1adb520b500cee4570f4c071d90.png";